import React, { useState } from "react";
import Seo from "../components/Seo";
import { toast } from "sonner";
import { Info, Mail, AlertTriangle, ShieldCheck, Send, User, MessageSquare } from "lucide-react";

const pages = {
  about: {
    icon: Info,
    title: "About Us",
    content: [
      "Maha Games Apps brings all Yono games together in one place, helping you explore yono apps, yono 777 and yono arcade. Compare Yono games by signup bonus, minimum withdrawal and download options before choosing an app.",
      "We track nearly 90 apps and keep every listing updated with the latest signup bonus, withdrawal limit and the official APK link. Whether you want a new Yono game or an all Yono game list, this is the page to bookmark.",
      "Our small team tests download links, re-checks bonus amounts and rewrites every app guide by hand, so no two pages on this site carry the same text. We are independent reviewers - the apps belong to their own companies and your money never passes through us.",
    ],
  },
  disclaimer: {
    icon: AlertTriangle,
    title: "Disclaimer",
    content: [
      "Everything published on Maha Games Apps is editorial content written by independent reviewers. We have no ownership stake in any app we list, we are not an agent or partner of their operators, and we never receive, hold or move money on behalf of players. Each app is governed solely by the terms and conditions of the company that runs it.",
      "Real-money gaming carries financial risk: deposits can be lost in full, and the habit can turn compulsive. Decide a spending cap before installing anything, never deposit to recover a loss, and make sure nobody under the age of 18 uses these apps on your device.",
      "Legal position: following the Promotion and Regulation of Online Gaming Act, 2025, online money games are prohibited in India, and a number of states had already banned or restricted them earlier. You are responsible for checking the rules that apply where you live before downloading or depositing. Nothing on this site should be read as legal advice.",
      "All bonuses, offers and app details shown here are collected from public sources and can change at any time. Always confirm the final offer inside the app before you deposit.",
    ],
  },
  privacy: {
    icon: ShieldCheck,
    title: "Privacy Policy",
    content: [
      "Maha Games Apps does not ask you to create an account, and we never collect your OTP, UPI PIN, bank details or any payment information.",
      "We may use basic analytics to understand which pages are popular, so we can keep the games list fresh and useful. This data is anonymous and never shared with third parties for marketing.",
      "When you tap a download button you leave our site and install an app run by its own company. Their privacy policy applies from that moment - please read it inside the app.",
      "If you have any privacy questions, reach us any time from the Contact page.",
    ],
  },
};

const seoMeta = {
  about: { title: "About Maha Games Apps – Yono Games Review & Listing Site", description: "Learn what Maha Games Apps does: we track, check and list Yono rummy, slots and casino apps with their bonuses and withdrawal limits so you can pick safely." },
  contact: { title: "Contact Maha Games Apps – Report a Link or Suggest a Yono App", description: "Reach the Maha Games Apps team to report a broken APK link, correct a bonus amount or suggest a new Yono game for the list." },
  disclaimer: { title: "Disclaimer – Maha Games Apps", description: "Maha Games Apps is an independent review and listing site. We do not own, run or hold money for any Yono app. Read the full disclaimer and 18+ notice." },
  privacy: { title: "Privacy Policy – Maha Games Apps", description: "How Maha Games Apps handles visitor data: no accounts, no OTP or payment details collected, basic analytics only. Read our full privacy policy." },
};

const StaticPage = ({ page }) => {
  const meta = seoMeta[page] || seoMeta.about;
  const [form, setForm] = useState({ name: "", email: "", message: "" });

  if (page === "contact") {
    return (
      <div className="max-w-2xl mx-auto px-4 py-12">
        <Seo title={meta.title} description={meta.description} />
        <div className="text-center mb-8">
          <span className="inline-flex w-14 h-14 rounded-2xl bg-[#ffb224] items-center justify-center shadow-lg  mb-4">
            <Mail size={26} className="text-white" />
          </span>
          <h1 className="text-3xl sm:text-4xl font-extrabold text-white">
            Contact <span className="text-[#ffb224]">Us</span>
          </h1>
          <p className="text-emerald-50/70 mt-2 font-medium">Koi sawaal ya suggestion? Humse baat karein.</p>
        </div>

        <form
          className="bg-[#073c1b] border border-[#1c5f35] rounded-3xl p-6 sm:p-8 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.2)] flex flex-col gap-4"
          onSubmit={(e) => {
            e.preventDefault();
            toast.success("Message bhej diya gaya!", { description: "Hum jald hi aapko reply karenge. (demo)" });
            setForm({ name: "", email: "", message: "" });
          }}
        >
          <label className="flex flex-col gap-1.5">
            <span className="text-sm font-bold text-emerald-50/90 flex items-center gap-1.5"><User size={14} /> Name</span>
            <input
              required
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Aapka naam"
              className="bg-[#013013] text-white border border-[#1c5f35] rounded-xl px-4 py-3 text-sm outline-none focus:border-[#ffb224] transition-all"
            />
          </label>
          <label className="flex flex-col gap-1.5">
            <span className="text-sm font-bold text-emerald-50/90 flex items-center gap-1.5"><Mail size={14} /> Email</span>
            <input
              required
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="you@example.com"
              className="bg-[#013013] text-white border border-[#1c5f35] rounded-xl px-4 py-3 text-sm outline-none focus:border-[#ffb224] transition-all"
            />
          </label>
          <label className="flex flex-col gap-1.5">
            <span className="text-sm font-bold text-emerald-50/90 flex items-center gap-1.5"><MessageSquare size={14} /> Message</span>
            <textarea
              required
              rows={4}
              value={form.message}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              placeholder="Apna message likhein..."
              className="bg-[#013013] text-white border border-[#1c5f35] rounded-xl px-4 py-3 text-sm outline-none focus:border-[#ffb224] transition-all resize-none"
            />
          </label>
          <button
            type="submit"
            className="mt-2 inline-flex items-center justify-center gap-2 bg-[#ffb224] hover:bg-[#ffc14d] text-white font-bold py-3.5 rounded-xl shadow-lg  hover:-translate-y-0.5 active:scale-95 transition-all duration-200"
          >
            <Send size={17} /> Send Message
          </button>
        </form>
      </div>
    );
  }

  const data = pages[page] || pages.about;
  const Icon = data.icon;

  return (
    <div className="max-w-3xl mx-auto px-4 py-12">
      <Seo title={meta.title} description={meta.description} />
      <div className="text-center mb-8">
        <span className="inline-flex w-14 h-14 rounded-2xl bg-[#ffb224] items-center justify-center shadow-lg  mb-4">
          <Icon size={26} className="text-white" />
        </span>
        <h1 className="text-3xl sm:text-4xl font-extrabold text-white">
          {data.title.split(" ")[0]} <span className="text-[#ffb224]">{data.title.split(" ").slice(1).join(" ")}</span>
        </h1>
      </div>
      <div className="bg-[#073c1b] border border-[#1c5f35] rounded-3xl p-6 sm:p-8 shadow-[0_10px_40px_-15px_rgba(124,58,237,0.2)] flex flex-col gap-4">
        {data.content.map((para) => (
          <p key={para.slice(0, 40)} className="text-emerald-50/80 leading-relaxed text-[15px]">{para}</p>
        ))}
      </div>
    </div>
  );
};

export default StaticPage;
